module.exports = __webpack_public_path__ + "static/media/DSCF0200.b166f4bc.jpg";